// third-party
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// types
import { DefaultRootStateProps } from 'types';

const initialState: DefaultRootStateProps['healthContent'] = {
    loading: true,
    loadingThirdLevel: false,
    updating: false,
    error: null,
    firstLevel: [],
    secondLevelProducts: [],
    secondLevelImages: [],
    secondLevelFacets: [],
    thirdLevelProducts: [],
    thirdLevelImages: [],
    thirdLevelFacets: []
};

const slice = createSlice({
    name: 'health-content',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getFirstLevel.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFirstLevel.fulfilled, (state, action) => {
                state.loading = false;
                state.firstLevel = action.payload.response;
            });
        builder
            .addCase(getZeroLevel.pending, (state) => {
                state.loading = true;
            })
            .addCase(getZeroLevel.fulfilled, (state, action) => {
                state.loading = false;
                state.firstLevel = action.payload.response;
            });
        builder
            .addCase(getSecondLevelProducts.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSecondLevelProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.secondLevelProducts = action.payload.response;
            });
        builder
            .addCase(getSecondLevelImages.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSecondLevelImages.fulfilled, (state, action) => {
                state.loading = false;
                state.secondLevelImages = action.payload.response;
            });
        builder
            .addCase(getSecondLevelFacets.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSecondLevelFacets.fulfilled, (state, action) => {
                state.loading = false;
                state.secondLevelFacets = action.payload.response;
            });
        builder
            .addCase(getThirdLevelProducts.pending, (state) => {
                state.loadingThirdLevel = true;
            })
            .addCase(getThirdLevelProducts.fulfilled, (state, action) => {
                state.loadingThirdLevel = false;
                state.thirdLevelProducts = action.payload.response;
            });
        builder
            .addCase(getThirdLevelImages.pending, (state) => {
                state.loadingThirdLevel = true;
            })
            .addCase(getThirdLevelImages.fulfilled, (state, action) => {
                state.loadingThirdLevel = false;
                state.thirdLevelImages = action.payload.response;
            });
        builder
            .addCase(getThirdLevelFacets.pending, (state) => {
                state.loadingThirdLevel = true;
            })
            .addCase(getThirdLevelFacets.fulfilled, (state, action) => {
                state.loadingThirdLevel = false;
                state.thirdLevelFacets = action.payload.response;
            });
    }
});
export default slice.reducer;

export const getZeroLevel = createAsyncThunk(`${slice.name}/zero-level`, async () => {
    const response = await axios.get(`/loolu/api/health-content/metrics/zero-level`, {});
    return response.data;
});

const getFirstLevel = createAsyncThunk(`${slice.name}/fisrt-level`, async () => {
    const response = await axios.get(`/loolu/api/health-content/metrics/first-level`, {});
    return response.data;
});

export const getSecondLevelProducts = createAsyncThunk(`${slice.name}/second-level/products`, async (idMerchant: number) => {
    const response = await axios.get(`/loolu/api/health-content/metrics/products/second-level?idMerchant=${idMerchant}`, {});
    return response.data;
});

export const getSecondLevelImages = createAsyncThunk(`${slice.name}/second-level/img`, async (idMerchant: number) => {
    const response = await axios.get(`/loolu/api/health-content/metrics/images/second-level?idMerchant=${idMerchant}`, {});
    return response.data;
});

export const getSecondLevelFacets = createAsyncThunk(`${slice.name}/second-level/facets`, async (idMerchant: number) => {
    const response = await axios.get(`/loolu/api/health-content/metrics/specifications/second-level?idMerchant=${idMerchant}`, {});
    return response.data;
});

export const getThirdLevelProducts = createAsyncThunk(
    `${slice.name}/third-level/products`,
    async (props: { idProd: number; idMerchant: string | null }) => {
        const response = await axios.get(`/loolu/api/health-content/metrics/products/third-level`, {
            params: { productId: props.idProd, idMerchant: props.idMerchant }
        });
        return response.data;
    }
);

export const getThirdLevelImages = createAsyncThunk(
    `${slice.name}/third-level/images`,
    async (props: { idProd: number; idMerchant: string | null }) => {
        const response = await axios.get(`/loolu/api/health-content/metrics/images/third-level`, {
            params: { productId: props.idProd, idMerchant: props.idMerchant }
        });
        return response.data;
    }
);

export const getThirdLevelFacets = createAsyncThunk(
    `${slice.name}/third-level/facets`,
    async (props: { idProd: number; idMerchant: string | null }) => {
        const response = await axios.get(`/loolu/api/health-content/metrics/specifications/third-level`, {
            params: { productId: props.idProd, idMerchant: props.idMerchant }
        });
        return response.data;
    }
);
